module.exports = __webpack_public_path__ + "img/xzpremium.c5ac5126.jpg";